module.exports = __webpack_public_path__ + "img/3_hadi fish.ca9ec4ac.jpg";